import { ReferentialKey } from "api/referential";
import { useAppSelector } from "app/hooks";
import { useCallback } from "react";
import { selectReferentialData } from "../selectors/selectReferentialDataByKey";

export const useReferentialUtils = () => {
  const referentialsData = useAppSelector(selectReferentialData);

  const getReferentialCodeById = useCallback(
    (referentialKey: ReferentialKey, code?: string) => {
      if (!code) {
        return;
      }
      return referentialsData[referentialKey].find(ref => ref.code === code)?.id;
    },
    [referentialsData]
  );

  /** Inverse de getReferentialCodeById : retrouve le code d'une entrée à partir de son id. */
  const getReferentialCodeFromId = useCallback(
    (referentialKey: ReferentialKey, id?: string) => {
      if (!id) {
        return;
      }
      return referentialsData[referentialKey].find(ref => ref.id === id)?.code;
    },
    [referentialsData]
  );

  return {
    getReferentialCodeById,
    getReferentialCodeFromId
  }
}
